export default __webpack_public_path__ + "static/media/screen-01.09117650.svg";